<template>
    <div class="literatures">
    <div class="literatures_component">
        <h3 class="literatures_title">日本の文学</h3>
        <p class="literatures-title-note">日本を代表する名作</p>
        <div class="literatures-list">
            <ul class="columns is-mobile is-multiline">
                <li class="column is-one-fifth-desktop is-one-quarter-tablet is-half-mobile" v-for="list in literature_list.literature_list_data" :key="list.index">
                    <span class="literatures-list_link" @click="openModal(list)">
                        <img :src="list.url" alt="list.title">
                        <h3>{{list.title}}</h3>
                    </span>
                    <p class="literatures-list_author">{{list.author}}</p>
                </li>
            </ul>
        </div>
        <section>
            <b-modal v-model="isCardModalActive" :width="500">
                <div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-128x128">
                                <img :src="this.modal_literature_data.url">
                            </figure>
                        </div>
                        <div class="media-content">
                            <p class="title is-4">{{this.modal_literature_data.title}}</p>
                            <div class="author_info">
                                <p>{{this.modal_literature_data.author}}</p>
                                <p>{{this.modal_literature_data.publication}}年</p>
                                <p>{{this.modal_literature_data.total_character_count}}文字</p>
                                <router-link :to="{ name: 'Literature', params: { id: this.modal_literature_data.params }}">読む→</router-link>
                            </div>
                            <div class="outline">
                                <p class="outline_text">あらすじ</p>
                                <hr/>
                                <p>{{this.modal_literature_data.outline}}</p>
                                <p class="amazon_link">
                                    <a :href="this.modal_literature_data.amazon_link">
                                        <span class="icon-amazon icon_amazon"></span> amazonで見る</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="content modal_button">
                    <router-link :to="{ name: 'Literature', params: { id: this.modal_literature_data.params }}"><b-button>読む</b-button></router-link>  
                </div>

                <footer class="modal-card-foot">
                    <span class="container modal_button">
                    <button class="button is-small" @click="closeModal">閉じる</button>
                    </span>
                </footer>
                </div>
            </b-modal>
        </section>
    </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
        title: '',
        author: '',
        outline: '',
        total_character_count: '',
        literature_list:[],
        isCardModalActive: false,
        modal_literature_data:[]
        }
    },
    created(){
        const row_literature_list = require('../json_file/literature/literature_list.json')
        this.literature_list = row_literature_list
    },
    mounted(){
        const title = "日本の文学｜Flatte"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
    },
    methods:{
        openModal(value){
            this.modal_literature_data = value
            this.isCardModalActive = true
        },
        closeModal(){
            this.isCardModalActive = false;
        }
    }
}
</script>

<style>
h3 {
    font-weight: bold;
    display: block;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}
.literatures{
    background-color: #F6F9F9;
}
.literatures_component{
    max-width: 960px;
    margin: 0px auto;
    padding: 40px;
}
.literatures_title{
    font-size:2em;
}
.literatures-title-note {
    margin-top: 0.2rem;
    font-size: 0.9rem;
    color: gray;
}
.literatures-list{
    margin: 24px 0 24px 0;
}
.literatures-list_link{
    color: #1EA1F2;
}
.literatures-list_author{
    font-size: 0.9rem;
}
hr{
    margin:4px;
}
.card{
  border-radius: 0.5em;
}
.modal-background {
    background-color: rgba(0,0,0,0.35);
}
.outline{
    padding:8px 0 16px 16px;
    text-align:left;
}
.outline_text{
    font-weight: bold;
}
.author_info{
    padding:16px;
    text-align:right;
}
.modal_button{
    padding:8px;
    text-align: center;
}
.amazon_link{
    padding: 16px 0;
}
.icon_amazon{
  vertical-align: text-bottom;
}
</style>